const localeEn = {
  SC_COURSE_TAB_TITLE: `Courses`,
  SC_EMPTY_STATE_TITLE: `You haven't saved any courses yet`,
  SC_EMPTY_STATE_MESSAGE_PT1: `When you find a course you like, click on the`,
  SC_EMPTY_STATE_MESSAGE_PT2: `icon to save it and enroll later.`,
  SC_GO_TO_CATALOG: `Go to catalog`,
};
export default localeEn;
